import { useUserStore } from 'store/modules';

export default function (to, from, next) {
    const userStore = useUserStore();

    if (to.matched.some((record) => record.meta.developer) && !userStore.isDeveloper) {
        next('/');
    } else {
        next();
    }
}
